import React, { FC, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@root/styles/icons';
import { SingleDatePicker } from 'react-dates';
import { useTranslations } from '@lang';
import { DesktopLabel } from '../../DateRangeInput/DesktopInput/DesktopInput.styles';
import { DateInputProps } from '../types';
import { DesktopPickerWrapper } from './DesktopInput.styles';
import { DATE_FORMAT } from '../constants';

export const DesktopInput: FC<DateInputProps> = ({ startDate, onDateChange = () => {} }) => {
  const { t } = useTranslations();
  const [focused, setFocused] = useState(false);
  const [selectedDate, setSelectedDate] = useState(startDate);

  return (
    <DesktopPickerWrapper>
      <DesktopLabel>{t('common.date')}</DesktopLabel>
      <SingleDatePicker
        focused={focused}
        onFocusChange={({ focused }) => setFocused(focused)}
        hideKeyboardShortcutsPanel
        date={selectedDate}
        id="your_unique_start_date_id"
        onDateChange={(date) => {
          if (date) {
            setSelectedDate(date);
            onDateChange(date);
          }
        }}
        displayFormat={DATE_FORMAT}
        navNext={<ChevronRightIcon />}
        navPrev={<ChevronLeftIcon />}
      />
    </DesktopPickerWrapper>
  );
};
